import { render, staticRenderFns } from "./ReviewSitesUpload.vue?vue&type=template&id=14b70a74&scoped=true"
import script from "./ReviewSitesUpload.vue?vue&type=script&lang=js"
export * from "./ReviewSitesUpload.vue?vue&type=script&lang=js"
import style0 from "./ReviewSitesUpload.vue?vue&type=style&index=0&id=14b70a74&prod&scoped=true&lang=css"
import style1 from "./ReviewSitesUpload.vue?vue&type=style&index=1&id=14b70a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b70a74",
  null
  
)

export default component.exports